import "core-js/modules/es.array.push.js";
export default class GoogleTagManager {
  static init() {
    let pixel = process.env.VUE_APP_GTM;
    if (!window.dataLayer && pixel) {
      this.managerCode(window, document, 'script', 'dataLayer', pixel);
    }
    return new this();
  }
  static initWith(pixel) {
    this.managerCode(window, document, 'script', 'dataLayer', pixel);
    return new this();
  }
  pageView(data) {
    if (!window.dataLayer) return this;
    dataLayer.push(Object.assign({
      event: 'PageView'
    }, data));
    return this;
  }
  static managerCode(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  }
}